const map = {
  // 人事&行政
  performanceDashboard: () =>
    import('@/views/personnelmanagement/PerformanceDashboard'),
  inspectionConfiguration: () =>
    import('@/views/personnelmanagement/InspectionConfiguration'),
  inspectionScore: () => import('@/views/personnelmanagement/InspectionScore'),
  inspectionHistoryScore: () =>
    import('@/views/personnelmanagement/InspectionHistoryScore'),
  inspectionCurrentMonth: () =>
    import('@/views/personnelmanagement/InspectionCurrentMonth'),
  personnel: () => import('@/views/personnelmanagement/Personnel'),
  personnelStructure: () =>
    import('@/views/personnelmanagement/PersonnelStructure'),
  staffRecords: () => import('@/views/personnelmanagement/StaffRecords'),
  staffAttendance: () => import('@/views/personnelmanagement/StaffAttendance'),
  staffWages: () => import('@/views/personnelmanagement/StaffWages'), // 员工工资
  fiverisksGold: () => import('@/views/personnelmanagement/FiverisksGold'), // 五险一金
  assetManagement: () => import('@/views/personnelmanagement/AssetManagement'), // 资产管理
  basicParamsConfig: () =>
    import('@/views/personnelmanagement/BasicParamsConfig'), // 基础参数配置

  // 短信
  signList: () => import('@/views/message/SignList'),
  templateList: () => import('@/views/message/TemplateList'),
  messageList: () => import('@/views/message/MessageList')
}

export default map
